export function formatNumber(value) {
  return new Intl.NumberFormat('en-US', {
    maximumSignificantDigits: 3,
  }).format(value)
}

export function stackNumber(value) {
  if (value > 1000) {
    return `$${Math.floor(value / 1000).toLocaleString()}K`
  }

  return `$${value}`
}

export function dollarNumber(value) {
  return `$${formatNumber(value)}`
}

type LongDollarNumberOptions = {
  wholeDollar: boolean
}
// There is a cleaner way to do this with style: 'currency' and trailingZeroDisplay: 'stripIfInteger',
// but our current version of typescript doesn't support it
export function longDollarNumber(
  value: string | number,
  { wholeDollar }: LongDollarNumberOptions = { wholeDollar: false }
) {
  let numValue = typeof value === 'string' ? parseFloat(value) : value
  if (wholeDollar) {
    numValue = Math.floor(numValue)
  }
  const showCents = !Number.isInteger(numValue)
  const options = { maximumFractionDigits: 2, minimumFractionDigits: showCents ? 2 : null }
  const formattedValue = new Intl.NumberFormat('en-US', options).format(numValue)
  return `$${formattedValue}`
}
